export const isNew = (item) => {
    const twoWeeks = 14 * 24 * 60 * 60 * 1000;
    const today = new Date();
    const thatDay = new Date(item.newArrival);

    return today - thatDay < twoWeeks;
}